module.exports = __webpack_public_path__ + "img/news_list_icon.9e8fbf1d.png";